const ITEMS = [
  "ENTERPRISE GPU COMPUTE",
  "AI INFRASTRUCTURE",
  "ADVANCED COMPONENTS",
  "GLOBAL SOURCING",
  "UAE EXECUTION",
  "DATA CENTRE SYSTEMS",
  "MISSION-CRITICAL IT",
];

export const Marquee = () => (
  <div className="border-y border-midnight/10 bg-[#FAFAFA] py-5 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center font-heading text-[11px] font-medium tracking-[0.35em] text-midnight/35 whitespace-nowrap">
          <span className="px-10">{t}</span>
          <span className="text-gold/70 text-[8px]">◆</span>
        </span>
      ))}
    </div>
  </div>
);
